import Vue from 'vue';
import Router from 'vue-router';
import localforage from 'localforage';
// import Main from '@/pages/main';
import Sub from '@/pages/sub';
import Account from '@/pages/sub/account';
import Role from '@/pages/sub/role';
import Store from '@/pages/sub/store';
import Login from '@/pages/login';
import CreateUser from '@/pages/create-user';
import RhinoLogin from '@/pages/rhino-login';
import SevenElevenLogin from '@/pages/seven-eleven-login';
import NotFound from '@/pages/404';
import WorkwechatCallback from '@/pages/workwechat-callback';
// import store from '@/store';
import {
  PATH_LOGIN,
  PATH_CREATE_USER,
  PATH_RHINO_LOGIN,
  PATH_SEVEN_ELEVEN_LOGIN,
  AUTH_ROUTES_CONFIG,
} from '@/consts';
import { getFirstValidRoute } from '@/utils/helpers';
import microApps from '@/micro-apps';

const microAppActiveRuleList = microApps.map(({ activeRule }) => activeRule.replace(/^\//, ''));

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: PATH_LOGIN,
      name: 'Login',
      component: Login,
    },
    {
      path: PATH_CREATE_USER,
      name: 'CreateUser',
      component: CreateUser,
    },
    {
      path: PATH_RHINO_LOGIN,
      name: 'RhinoLogin',
      component: RhinoLogin,
    },
    {
      path: PATH_SEVEN_ELEVEN_LOGIN,
      name: 'SevenElevenLogin',
      component: SevenElevenLogin,
    },
    {
      path: '/workwechat-callback',
      name: 'WorkwechatCallback',
      component: WorkwechatCallback,
    },
    {
      path: `/(${microAppActiveRuleList.concat('main').map(rule => `${rule}[^]*`).join('|')})`,
      name: 'Sub',
      component: Sub,
      meta: {
        authRequired: true,
      },
      children: [
        {
          path: 'account',
          name: 'Account',
          component: Account,
        },
        {
          path: 'role',
          name: 'Role',
          component: Role,
        },
        {
          path: 'store',
          name: 'Store',
          component: Store,
        },
      ],
      exact: false,
    },
    {
      path: '*',
      // redirect: PATH_INDEX,
      name: 'NotFound',
      component: NotFound,
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (to.path === '/') {
    const authRoutesConfig = await localforage.getItem(AUTH_ROUTES_CONFIG);
    if (authRoutesConfig) {
      // 如果有权限树，则跑到第一个路由
      const firstValidRoute = getFirstValidRoute(authRoutesConfig);
      next(firstValidRoute);
    } else {
      // 没有没有权限树，则退回到login
      next(process.env.LOGIN_PATH);
    }
  } else {
    next();
  }
});

export default router;
